export const AlertMessage = ({ type, message }) => {
    if (!message) return null;

    const typeClasses = {
        error: 'text-red-500 bg-red-50',
        success: 'text-green-500 bg-green-50'
    };

    return (
        <div className={`mb-3 p-2 rounded text-xs ${typeClasses[type]}`}>
            {message}
        </div>
    );
};
